export default "__VITE_ASSET__Bbnm4uRG__"